module.exports = __webpack_public_path__ + "static/media/kite1280.7849fb1a.png";